<template>
  <el-container
    id="container-store-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/store', query:{page:$route.query.frompage || 1} }">店鋪資訊 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">

        <el-form label-width="80px" @submit.native.prevent >

          <el-tabs value="common" type="card">
            <el-tab-pane label="通用" name="common">
              <!-- <el-form-item label="排序">
                <el-input v-model="form.Sort" type="number" min="0" step="1"></el-input>
              </el-form-item> -->
              <el-form-item label="地圖網址">
                <el-input v-model="form.MapLink"></el-input>
              </el-form-item>

              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage"
                  ref="elupload"
                  accept="image/*"
                  class="el-upload-images"
                  drag
                  action
                  :multiple="true"
                  :auto-upload="true"
                  :http-request="onImageHTTPRequest">
                  <i class="el-icon-upload"></i>
                  <!-- <div class="el-upload__text">
                    將文件拖曳至此，或
                    <em>點擊上傳</em>
                  </div> -->
                </el-upload>

                <draggable v-model="form.Images"
                  handle=".drag-target-img">
                  <div v-for="(obj,idx) in form.Images" :key="`car-image-info-${idx}`" v-show="!obj.DeletedAt"
                    class="img-wrapper">
                    <img class="drag-target-img" :src="getImageURL(obj)"/>
                    <el-button @click.stop="confirmDeleteImage(idx)" type="danger" icon="el-icon-close" size="mini" circle></el-button>
                  </div>
                </draggable>

                <br>
                <p class="hint">建議上傳 1920x1080的圖片，以獲得最佳畫面呈現。</p>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>

          <el-tabs v-model="activeLang" type="card">
            <el-tab-pane label="繁中" name="tw">

              <el-form-item label="店鋪名稱">
                <el-input v-model="form.NameTw"></el-input>
              </el-form-item>

              <el-form-item label="店鋪描述">
                <el-input v-model="form.DescriptionTw" type="textarea" autosize></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">

              <el-form-item label="店鋪名稱">
                <el-input v-model="form.NameCn"></el-input>
              </el-form-item>

              <el-form-item label="店鋪描述">
                <el-input v-model="form.DescriptionCn" type="textarea" autosize></el-input>
              </el-form-item>

            </el-tab-pane>
            <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">

              <el-form-item label="店鋪名稱">
                <el-input v-model="form.NameEn"></el-input>
              </el-form-item>

              <el-form-item label="店鋪描述">
                <el-input v-model="form.DescriptionEn" type="textarea" autosize></el-input>
              </el-form-item>

            </el-tab-pane>
            <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">

              <el-form-item label="店鋪名稱">
                <el-input v-model="form.NameJp"></el-input>
              </el-form-item>

              <el-form-item label="店鋪描述">
                <el-input v-model="form.DescriptionJp" type="textarea" autosize></el-input>
              </el-form-item>

            </el-tab-pane>
          </el-tabs>
        </el-form>

        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">一鍵翻譯會自動將繁體中文的內容翻譯成其他語言，<br>並且覆蓋資料!<br><br>包含圖片影片也會覆蓋，包含內容編輯器</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">一鍵翻譯</el-button>
        </el-tooltip>

        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import Config from '@/assets/js/config.js'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
// import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
import ImageThumbnailer from '@/utils/ImageThumbnailer.js'
import draggable from 'vuedraggable'
import { genRandomStr } from '@/utils/random.js'

export default {
  // mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave, MixinProcessImageFile],
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinProcessImageFile, MixinOfTranslation],
  components: {
    LeftMenu,
    TopHeader,
    draggable
  },
  data () {
    return {
      oriObj: {},
      form: {
        IsActive: true,
        Images: []
      },
      activeLang: 'tw',
      isLoading: false,
      loadingHint: ''
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createStore'
    },
    title () {
      return this.isEdit ? this.form.NameTw : '新增'
    }
  },
  methods: {
    getImageURL (obj) {
      return this.getAbsoluteURL(obj.ImageURLX1 || obj.ImageURLX2 || obj.ImageURLX3)
      // return `${Config.WEBURL}/webimage/${obj.URLKey}`
    },
    getAbsoluteURL (s) {
      if (!s) return s
      if (s.startsWith('/')) return Config.WEBURL + s
      return s
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      var payload = JSON.parse(JSON.stringify(this.form))
      payload.Sort = parseInt(payload.Sort)

      // 圖片順序
      let randomString = genRandomStr(10)
      for (let i = 0; i < payload.Images.length; ++i) {
        payload.Images[i].Sort = i + 1
        if (!payload.Images[i].URLKey) payload.Images[i].URLKey = `${randomString} - ${i + 1}`
      }

      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      let promise = this.isEdit
        ? this.$services.store.edit(this, payload)
        : this.$services.store.add(this, payload)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'store-list', query: { page: this.$route.query.frompage || 1 } })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.store.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.store.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.store.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown store for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.MapLink) {
        errMsg = '請輸入Google Map網址'
      } else if (!this.form.Images || !this.form.Images.length) {
        errMsg = '請上傳圖片'
      } else if (!this.form.NameTw) {
        errMsg = '請輸入名稱(繁中)'
      } else if (!this.form.NameEn) {
        errMsg = '請輸入名稱(英文)'
      } else if (!this.form.NameJp) {
        errMsg = '請輸入名稱(日文)'
      } else if (!this.form.DescriptionTw) {
        errMsg = '請輸入描述(繁中)'
      } else if (!this.form.DescriptionEn) {
        errMsg = '請輸入描述(英文)'
      } else if (!this.form.DescriptionJp) {
        errMsg = '請輸入描述(日文)'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      this.isLoading = true

      const translateKeys = ['Name', 'Description']
      let promises1 = this.translateForm(translateKeys)

      Promise.all([promises1]).then(() => {
        this.isLoading = false
      })
    },
    translateForm (translateKeys) {
      let genPayload = () => {
        var texts = []

        for (var i = 0; i < translateKeys.length; ++i) {
          let key = translateKeys[i]
          if (this.form[key + 'Tw']) texts.push(this.form[key + 'Tw'])
        }

        return {
          'Texts': texts,
          languages: this.translationLanguages
        }
      }
      let onTranslateCompleted = (result) => {
        var i

        var idx = 0
        for (i = 0; i < translateKeys.length; ++i) {
          let key = translateKeys[i]
          if (this.form[key + 'Tw']) {
            let langs = this.languages.filter(o => o !== 'Tw')
            for (let lang of langs) {
              let googleLang = Config.googleLanguageMap[lang]
              this.$set(this.form, key + lang, result.Texts[googleLang][idx])
            }
            idx += 1
          }
        }
      }
      let payload = genPayload()
      if (!payload.Texts.length) {
        return alert('您尚未輸入任何文字至資料表單')
      }
      return this.$services.translation.translate(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) onTranslateCompleted(res.data.result)
      }).catch(this.$handleServiceError)
    },
    async onImageHTTPRequest (e) {
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) return this.$message({ message: `請上傳圖片檔案`, type: 'error' })

      this.$refs.elupload.clearFiles()

      // 1. 壓縮成兩個尺寸
      let requiredSize = { w: 1920, h: 1080 }
      let compressOptions = [
        {
          maxWidth: requiredSize.w,
          maxHeight: requiredSize.h
        },
        {
          maxWidth: requiredSize.w * 2 / 3,
          maxHeight: requiredSize.h * 2 / 3
        },
        {
          maxWidth: requiredSize.w / 3,
          maxHeight: requiredSize.h / 3
        }
      ]

      let compressPromiseList = []
      for (let opts of compressOptions) {
        let promise = new Promise((resolve, reject) => {
          ImageThumbnailer.shared.requestCompress(
            e.file,
            blob => {
              resolve(blob)
            },
            opts
          )
        })
        compressPromiseList.push(promise)
      }
      Promise.all(compressPromiseList).then(results => {
        onThumb(results)
      })
      // 2 上傳圖片
      let uploadPathPrefixList = [
        this.isEdit
          ? `store/${this.form.ID}/image-`
          : `store/image@3x-${this.form.NameTw}-`,
        this.isEdit
          ? `store/${this.form.ID}/image-`
          : `store/image@2x-${this.form.NameTw}-`,
        this.isEdit
          ? `store/${this.form.ID}/image-`
          : `store/image-@1x-${this.form.NameTw}-`
      ]
      const onThumb = (blobs) => {
        // 上傳圖片
        uploadBlobs(blobs)
      }

      const uploadBlobs = (blobs) => {
        this.isProcessingImage = true

        let uploadPromiseList = []
        for (var i = 0; i < blobs.length; ++i) {
          let pathPrefix = uploadPathPrefixList[i]

          let promise = this.$services.firebase.upload(
            blobs[i],
            pathPrefix
          )
          uploadPromiseList.push(promise)
        }

        Promise.all(uploadPromiseList).then(urls => {
          onImageUploaded(urls)
        })
      }
      // 3. 上傳後callback 顯示圖片
      const onImageUploaded = (urls) => {
        this.isProcessingImage = false
        this.form.Images.push({
          // SavedAt: moment().format(),
          ImageURLX1: urls[2],
          ImageURLX2: urls[1],
          ImageURLX3: urls[0]
        })
      }
    },
    confirmDeleteImage (idx) {
      if (window.confirm('確定刪除此圖片?')) {
        if (this.form.Images[idx].ID && this.form.Images[idx].ID > 0) {
          this.form.Images[idx].DeletedAt = moment().format()
          this.form.Images[idx].DeletedBy = this.$store.state.admin.ID
        } else {
          this.form.Images.splice(idx, 1)
        }
      }
    }
  },
  created () {
    var formSource = null
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.store.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.store.list[idx]
        formSource = JSON.parse(JSON.stringify(this.oriObj))

        this.form = formSource
      } else {
        console.error(`unknown store for id ${id}`)
      }
    }

    // cache
    // this.cacheKey = 'cache-store-' + (this.isEdit ? this.oriObj.ID : 0)
    // let cache = this.getCache()
    // if (cache) {
    //   this.confirmLoadCache().then(result => {
    //     if (result !== 'loaded') return
    //     let cacheForm = JSON.parse(cache)
    //     this.form = cacheForm
    //   }).catch(err => {
    //     console.error(err)
    //   })
    // }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.btn-set-url {
  position: absolute;
  top: 26px;
  right: 205px;
}
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 300px;
  right: 205px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}

.url-hint {
  position: absolute;
  top: 0;
  left: 20px;
  color: gray;
  font-size: 14px;
}
</style>

<style scoped>

.img-wrapper {
  width: 100px;
  height: 100px;
  display: inline-block;
  float: left;
  margin-left: 15px;
  position: relative;
  cursor: pointer;
}
.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.is-cover .cover-hint {
  display: block;
}
.img-wrapper .el-button {
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;

  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cover-hint {
  display: none;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: cornflowerblue;
  width: 2.5em;
  height: 1.5em;
  color: white;
  padding: 0;
  line-height: 1.5em;
}
</style>
